// extracted by mini-css-extract-plugin
module.exports = {"checkboxesContainer":"CreateEditClinics_checkboxesContainer__2tifb","emails":"CreateEditClinics_emails__1PgLI","emailTagLabel":"CreateEditClinics_emailTagLabel__3L0Cq"};